var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "keywordbox from-ipt-width" },
    [
      _vm._l(_vm.labelarr, function (item, index) {
        return _c(
          "el-tag",
          {
            key: index,
            staticClass: "mr5",
            attrs: {
              type: "success",
              closable: "",
              "disable-transitions": false,
            },
            on: {
              close: function ($event) {
                return _vm.labelhandleClose(item)
              },
            },
          },
          [_vm._v(_vm._s(item) + " ")]
        )
      }),
      _c("el-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.labelarr.length < 20,
            expression: "labelarr.length < 20",
          },
        ],
        staticClass: "keywordbox_ip",
        attrs: {
          size: "small",
          placeholder: "输入后回车",
          maxlength: "32",
          "show-word-limit": "",
          disabled: _vm.isDisabled,
        },
        on: { change: _vm.addlabel },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = typeof $$v === "string" ? $$v.trim() : $$v
          },
          expression: "val",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }